<div class="airo-chat-container font-13">
  <mat-radio-group
    [(ngModel)]="selectedMode"
    (change)="onModeChange($event)"
    class="d-block"
    id="airo_mode"
  >
    <mat-radio-button value="airo-web">Airo Web</mat-radio-button>
    <mat-radio-button value="airo-data" class="mx-4"
      >Airo Data</mat-radio-button
    >
  </mat-radio-group>
  <div class="d-flex flex-column">
    <mat-form-field appearance="outline" class="query-field">
      <textarea
        matInput
        [(ngModel)]="query"
        (keydown.enter)="$event.shiftKey ? null : onAskAiro()"
      ></textarea>
    </mat-form-field>

    <button
      mat-flat-button
      color="primary"
      class="p-0 ml-auto"
      style="font-size: 11px; margin-top: -10px"
      [disabled]="isLoading"
      (click)="onAskAiro()"
    >
      Ask Airo
    </button>

    <!-- Loader -->
    <div *ngIf="isLoading" class="d-flex justify-content-center">
      <app-loading></app-loading>
    </div>

    <!-- Recent Queries Accordion -->
    <mat-accordion class="recent-accordion mt-2">
      <mat-expansion-panel [expanded]="false" hideToggle #recentPanel>
        <mat-expansion-panel-header>
          <mat-panel-title class="d-flex align-items-center gap-2 font-13">
            <mat-icon class="clock-icon">schedule</mat-icon>
            <span>Recent Queries</span>
            <span class="query-count-badge">{{ queriesToShow.length }}</span>
            <span class="spacer"></span>
            <mat-icon class="chevron-icon">expand_more</mat-icon>
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div *ngIf="queriesToShow.length === 0" class="no-queries">
          No recent queries yet.
        </div>
        <ul class="p-0" *ngIf="queriesToShow.length > 0">
          <li
            *ngFor="let q of queriesToShow"
            (click)="loadQuery(q)"
            class="recent-item d-flex align-items-center px-4 py-2"
          >
            <span
              [matTooltip]="
                selectedMode === 'airo-web' ? q.query : q.user_query
              "
              class="query-text"
              >{{ selectedMode === "airo-web" ? q.query : q.user_query }}</span
            >
          </li>
        </ul>
      </mat-expansion-panel>
    </mat-accordion>

    <div *ngIf="summary && !isLoading" class="signal-analysis-card">
      <!-- Section Header -->
      <div class="signal-analysis-header">
        <mat-icon class="analysis-icon">bar_chart</mat-icon>
        <span class="analysis-title">Signal Analysis</span>
      </div>

      <!-- Airo Badge + Timestamp -->
      <div class="airo-meta-row">
        <button mat-icon-button aria-label="Ask Airo" class="airo-ico-action">
          <img src="/assets/Icons/airoIcon.png" height="16px" />
        </button>
        <span class="generated-at"
          >Generated at {{ generatedAt | appFormat: "date_with_time" }}</span
        >
      </div>

      <!-- Report Content Box -->
      <div class="report-box">
        <markdown class="report-content">{{ summary }}</markdown>
        <div *ngIf="links.length" class="links-box">
          <h4>Sources</h4>

          <div class="links-grid">
            <div
              class="link-item"
              *ngFor="let link of links; let i = index"
              (click)="openUrl(link.url)"
            >
              <span class="citation">{{ i + 1 }}</span>
              <span class="link-text">{{ link.name }}</span>
              <span class="link-icon">
                <mat-icon>open_in_new</mat-icon>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
